export default () => {
  const cont = document.querySelector(".profile-jobInfo-wrapper");

  cont ? hideProfileInfo() : false;
  cont ? openShareModal() : false;

  function hideProfileInfo() {
    const wrappers = cont.querySelectorAll(".wrapper-hide");

    wrappers.forEach((wrapper) => {
      const wrapperTitle = wrapper.querySelector(".wrapper-title");

      const wrapperTitleHeight = wrapperTitle.offsetHeight;

      wrapperTitle.addEventListener("click", () => {
        if (wrapper.classList.contains("closed")) {
          wrapper.style.maxHeight = "100em";
        } else {
          wrapper.style.maxHeight = wrapperTitleHeight + "px";
        }
        wrapper.classList.toggle("closed");
      });
    });
  }
  function openShareModal() {
    const shareBtn = document.querySelector(".openShareModal");
    const modalBlock = document.querySelector(".share-links");
    const closeBtn = modalBlock.querySelector(".close-window");
    shareBtn.addEventListener("click", () => {
      modalBlock.classList.toggle("visible");
    });
    closeBtn.addEventListener("click", () => {
      modalBlock.classList.toggle("visible");
    });
  }
};
